<template>
  <v-menu
    bottom
    offset-y
    left
    max-width="350"
    max-height="100vh"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="mr-1"
        v-bind="attrs"
        v-on="on"
        icon
      >
        <v-badge
            :color="notificationsUnRead.length === 0 ? 'secondary' : 'primary'"
            left
            :dot="notificationsUnRead.length === 0"
            :content="notificationsUnRead.length"
          >
          <v-icon>mdi-bell-ring-outline</v-icon>
          </v-badge>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, index) in notifications"
        :key="index"
        @click="redirectNotification(item, $event)"
      >
        <v-list-item-avatar v-if="item && item.sender && item.sender.avatar_source">
          <v-img :src="item.sender.avatar_source"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <div v-html="$t(`notification.${item.message}`, { senderName: item.sender ? item.sender.name : '' })"/>
          <div class="subtitle-2 text--primary">{{ timeAgo(item.created_at, appLocale) }}</div>
        </v-list-item-content>
        <v-list-item-action v-if="!item.read_at">
          <v-icon color="primary">mdi-checkbox-blank-circle</v-icon>
        </v-list-item-action>
      </v-list-item>
      <v-divider v-if="notifications.length"></v-divider>
      <v-list-item>
        <v-list-item-title v-if="notifications.length">
          <router-link :to="{ name: 'notifications.index' }">{{ $t('View all') }}</router-link>
        </v-list-item-title>
        <v-list-item-title v-else>{{ $t("Don't have notifications") }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { get, call } from 'vuex-pathify'
// import EchoPusher from '@utils/echoPusher'
import { pusher } from '@/config'
import { timeAgo } from '@utils'

export default {
  name: 'ItemBarNotification',
  computed: {
    notifications: get('notification/notifications'),
    notificationsUnRead: get('notification/unRead'),
    appLocale: get('app/locale'),
    token: get('auth/token'),
    role: get('user/role'),
    userId: get('user/id'),
    companyId: get('user/companyId')
  },
  created() {
    this.fetch()
    if (pusher.key) {
      this.init()
    }
  },
  data() {
    return {
      interval: null
    }
  },
  methods: {
    fetch: call('notification/fetch'),
    read: call('notification/read'),
    attach: call('notification/attach'),
    timeAgo,

    init() {
      const vm = this

      // const { token, role, userId, companyId } = this

      // const chanel = `company.${companyId}`

      // const echo = new EchoPusher(token)

      // echo.listen(chanel, '.notification.created', function(e) {
      //   const notification = e.notification || null
      //   if (notification && (
      //     (role === 'admin' && notification.receiver_role === 'admin') ||
      //     (notification.user_id === userId)
      //   )) {
      //     vm.attach(notification)
      //   }
      // })

      // return false

      this.interval = setInterval(() => {
        vm.fetch()
      }, 30 * 1000)
    },

    redirectNotification(item, e) {
      e.preventDefault()

      const vm = this

      vm.read(item.id)

      switch (item.message) {
        case 'assigned_task':
          vm.$router.push({ name: 'my-workings.detail', params: { id: item.data.task_id } })
          break

        case 'completed_task':
          vm.$router.push({ name: 'my-workings.detail', params: { id: item.data.task_id } })
          break

        case 'completed_project':
          vm.$router.push({ name: 'projects.show', params: { id: item.data.project_id } })
          break

        case 'request_supporting':
          vm.$router.push({ name: 'tickets.detail', params: { id: item.data.ticket_id } })
          break

        case 'answer_solution':
          vm.$router.push({ name: 'tickets.detail', params: { id: item.data.ticket_id } })
          break

        case 'admin_reviewed':
          vm.$router.push({ name: 'projects.show', params: { id: item.data.project_id } })
          break
      }

      return false
    }
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  }
}
</script>
